import StudentSummary from './StudentSummary/StudentSummary';
import SortPanel from 'src/components/studentPages/StudentRealTimeActivity/activityTypes/StudentSortImagesActivity/SortPanel/SortPanel';
import QuestionControls from './QuestionControls/QuestionControls';
import { StyledConceptQuestActivity } from './ConceptQuestActivity.styled';
import useConceptQuestActivity from './useConceptQuestActivity.hook';
import useQuestionAudio from '@/shared/Activities/RealTimeActivity/Players/SortImagesActivity/useQuestionAudio.hook';
import GameSpinner from '@/shared/GameComponents/UI/GameSpinner/GameSpinner';

export default function ConceptQuestActivity({
  activity,
  activityConf,
  taskActivityConf,
  initialTaskProgress,
  taskProgressAPI,
  onFinishedActivity,
  restartGame,
}) {
  const { state, actions } = useConceptQuestActivity({
    activity,
    activityConf,
    taskActivityConf,
    initialTaskProgress,
    taskProgressAPI,
    onFinishedActivity,
  });

  useQuestionAudio({
    activityState: state,
    activityActions: actions,
  });

  return (
    <StyledConceptQuestActivity className="concept-quest-activity">
      {state.finished ? (
        <StudentSummary
          answers={state.answers}
          screens={state.screens}
          restartGame={restartGame}
        />
      ) : state.currentScreen ? (
        <>
          <SortPanel
            currentScreen={state.currentScreen}
            studentAnswers={state.answers}
            activityActions={actions.sharedActions}
            audioIndexPlaying={state.audioIndexPlaying}
          />
          <QuestionControls state={state} actions={actions} />
        </>
      ) : (
        <GameSpinner />
      )}
    </StyledConceptQuestActivity>
  );
}
